import { createValidateInputs } from "../forms/validate";
import { t } from "../i18n";

type Props<T> = {
  api: (props: { email: string }) => Promise<T>;
  onDone: (props: { details?: T; error?: any }) => void;
};
export default function <T>(props: Props<T>) {
  const Form = createValidateInputs();
  async function onSubmit() {
    const data = Form.Actions.getValuesSnakecase();
    return props
      ?.api?.({ email: data.email })
      .then((details) => {
        props.onDone?.({ details });
      })
      .catch((error) => {
        // console.log("error from validate ::: ", error);
        props.onDone?.({ error: error.message });
      });
  }
  return (
    <section class="flex flex-col my-auto">
      <Form.Email.Label title={t().forms.global.email.label} class="form-label" note={t().forms.global.email.hint}>
        <Form.Email.Input autocomplete="email" type="text" class="form-input" />
      </Form.Email.Label>
      <Form.Actions.Button
        class="form-btn"
        onSubmit={onSubmit}
        statusValid={t().forms.global.button.valid}
        statusInvalid={t().forms.global.button.invalid}
      />
    </section>
  );
}
